import { createReducer } from '@reduxjs/toolkit';
import type { Draft, PayloadAction } from '@reduxjs/toolkit';
import * as _ from 'lodash-es';

import * as Actions from './actions';
import type { DeletedObject } from './types';

export interface State {
  objects: { [key: string]: DeletedObject | undefined };
}

export const initialState: State = {
  objects: {},
};

type LoadDeletedObjectsSuccessAction = PayloadAction<
  { objects: DeletedObject[] },
  typeof Actions.LOAD_DELETED_OBJECTS_SUCCESS
>;
type RemoveDeletedObjectAction = PayloadAction<
  { object: DeletedObject },
  typeof Actions.REMOVE_DELETED_OBJECT
>;

const loadObjectsSuccess = (
  state: Draft<State>,
  action: LoadDeletedObjectsSuccessAction
) => {
  state.objects = { ...state.objects, ..._.keyBy(action.payload.objects, 'id') };
};

const removeObject = (state: Draft<State>, action: RemoveDeletedObjectAction) => {
  state.objects[action.payload.object.id] = undefined;
};

export const reducer = createReducer(initialState, (builder) => {
  builder.addCase(Actions.LOAD_DELETED_OBJECTS_SUCCESS, loadObjectsSuccess);
  builder.addCase(Actions.REMOVE_DELETED_OBJECT, removeObject);
});
